import React, { useRef } from "react";
import Button from "../Button";
import PropTypes from "prop-types";

const images = {
  zip: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n<path d="M8 0C6.9 0 6 0.9 6 2V30C6 31.1 6.9 32 8 32H28C29.1 32 30 31.1 30 30V8L22 0H8Z" fill="#E2E5E7"/>\r\n<path d="M24 8H30L22 0V6C22 7.1 22.9 8 24 8Z" fill="#B0B7BD"/>\r\n<path d="M30 14L24 8H30V14Z" fill="#CAD1D8"/>\r\n<path d="M26 26C26 26.55 25.55 27 25 27H3C2.45 27 2 26.55 2 26V16C2 15.45 2.45 15 3 15H25C25.55 15 26 15.45 26 16V26Z" fill="#84BD5A"/>\r\n<path d="M8.29001 24C7.78601 24 7.58601 23.513 7.87401 23.169L10.721 19.387H8.36101C7.66601 19.387 7.72201 18.405 8.36101 18.405H11.584C12.191 18.405 12.367 18.979 11.936 19.444L9.20901 22.985H11.808C12.448 22.985 12.528 24.001 11.745 24.001H8.29001V24Z" fill="white"/>\r\n<path d="M13.253 18.947C13.253 18.291 14.309 18.267 14.309 18.947V23.512C14.309 24.175 13.253 24.192 13.253 23.512V18.947Z" fill="white"/>\r\n<path d="M15.726 18.947C15.726 18.683 15.934 18.395 16.27 18.395H18.117C19.157 18.395 20.093 19.091 20.093 20.425C20.093 21.689 19.157 22.393 18.117 22.393H16.782V23.449C16.782 23.801 16.558 24 16.27 24C16.006 24 15.726 23.801 15.726 23.449V18.947ZM16.781 19.402V21.394H18.116C18.652 21.394 19.076 20.921 19.076 20.425C19.076 19.866 18.652 19.402 18.116 19.402H16.781Z" fill="white"/>\r\n<path d="M25 27H6V28H25C25.55 28 26 27.55 26 27V26C26 26.55 25.55 27 25 27Z" fill="#CAD1D8"/>\r\n</svg>\r\n',
  jpeg: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n<g clip-path="url(#clip0_10201_22041)">\r\n<path d="M21.1343 0H4.55029C4.08858 0 3.71429 0.374286 3.71429 1.10057V31.4286C3.71429 31.6257 4.08858 32 4.55029 32H27.4497C27.9114 32 28.2857 31.6257 28.2857 31.4286V7.416C28.2857 7.01829 28.2326 6.89029 28.1389 6.796L21.4897 0.146857C21.3954 0.0531429 21.2674 0 21.1343 0Z" fill="#E9E9E0"/>\r\n<path d="M21.4286 0.0862732V6.85713H28.1994L21.4286 0.0862732Z" fill="#D9D7CA"/>\r\n<path d="M10.8177 10.8572C12.2597 10.8572 13.4286 9.68823 13.4286 8.24629C13.4286 6.80436 12.2597 5.63544 10.8177 5.63544C9.3758 5.63544 8.20688 6.80436 8.20688 8.24629C8.20688 9.68823 9.3758 10.8572 10.8177 10.8572Z" fill="#F3D55B"/>\r\n<path d="M3.71429 22.2857H10H28.2857V16L22.5714 10.5714L16.5714 17.1429L13.4383 14.0097L3.71429 22.2857Z" fill="#26B99A"/>\r\n<path d="M27.4497 32H4.55029C4.08858 32 3.71429 31.6257 3.71429 31.164V22.2857H28.2857V31.164C28.2857 31.6257 27.9114 32 27.4497 32Z" fill="#14A085"/>\r\n<path d="M12.2434 24.3714V28.856C12.2434 29.1269 12.1937 29.3549 12.0949 29.5394C11.996 29.724 11.8629 29.8726 11.6966 29.9846C11.5297 30.0966 11.3383 30.1749 11.1223 30.2189C10.9057 30.2634 10.6834 30.2857 10.4543 30.2857C10.3394 30.2857 10.2051 30.2737 10.052 30.2503C9.89829 30.2269 9.73943 30.1909 9.57543 30.1411C9.41143 30.0914 9.25372 30.0354 9.10286 29.9731C8.95143 29.9109 8.824 29.8406 8.72 29.7623L9.11829 29.1297C9.17029 29.1657 9.24457 29.204 9.34114 29.2429C9.43714 29.2817 9.54286 29.3183 9.65771 29.352C9.772 29.3863 9.892 29.4154 10.0171 29.4417C10.1423 29.468 10.2594 29.4806 10.3686 29.4806C10.6446 29.4806 10.8646 29.4269 11.0286 29.3206C11.1926 29.2143 11.2794 29.0326 11.2903 28.7777V24.3714H12.2434Z" fill="white"/>\r\n<path d="M14.5794 30.2468H13.6417V24.4886H15.2977C15.5423 24.4886 15.7846 24.5274 16.024 24.6057C16.2634 24.684 16.4783 24.8011 16.6686 24.9571C16.8589 25.1131 17.0126 25.3023 17.1297 25.5234C17.2469 25.7446 17.3057 25.9931 17.3057 26.2697C17.3057 26.5617 17.256 26.8257 17.1572 27.0628C17.0583 27.3 16.92 27.4994 16.7429 27.6606C16.5657 27.8217 16.352 27.9468 16.1023 28.0354C15.8526 28.124 15.576 28.168 15.2743 28.168H14.5789L14.5794 30.2468ZM14.5794 25.2V27.4811H15.4389C15.5532 27.4811 15.6663 27.4617 15.7789 27.4223C15.8909 27.3834 15.9937 27.3194 16.0874 27.2308C16.1812 27.1423 16.2566 27.0188 16.3137 26.86C16.3709 26.7011 16.3994 26.5046 16.3994 26.2703C16.3994 26.1766 16.3863 26.068 16.3606 25.9463C16.3343 25.824 16.2812 25.7068 16.2006 25.5948C16.1194 25.4828 16.0063 25.3891 15.8606 25.3137C15.7143 25.2377 15.5217 25.2 15.2823 25.2H14.5794Z" fill="white"/>\r\n<path d="M22.5714 27.2777V29.504C22.4514 29.6554 22.3177 29.7783 22.1692 29.8748C22.0206 29.9714 21.8646 30.0508 21.7006 30.1131C21.5366 30.1754 21.3674 30.22 21.1926 30.2457C21.0177 30.2731 20.8452 30.2857 20.6732 30.2857C20.3292 30.2857 20.0132 30.2234 19.724 30.0983C19.4349 29.9731 19.1823 29.7886 18.9663 29.5434C18.7503 29.2983 18.5806 28.9914 18.4583 28.6217C18.336 28.252 18.2749 27.8246 18.2749 27.3406C18.2749 26.8566 18.336 26.4303 18.4583 26.0634C18.5806 25.696 18.7497 25.3903 18.9663 25.1457C19.1823 24.9006 19.436 24.7148 19.728 24.5868C20.0194 24.4588 20.3349 24.3954 20.6732 24.3954C20.9857 24.3954 21.2772 24.4474 21.548 24.5514C21.8189 24.656 22.0606 24.812 22.2743 25.02L21.6257 25.5983C21.5006 25.4468 21.3572 25.3377 21.196 25.2703C21.0343 25.2028 20.868 25.1686 20.696 25.1686C20.5034 25.1686 20.3194 25.2046 20.1452 25.2777C19.9703 25.3508 19.8143 25.4743 19.6766 25.6486C19.5383 25.8234 19.4303 26.048 19.3526 26.3246C19.2749 26.6011 19.2326 26.9388 19.2274 27.34C19.2326 27.7308 19.2732 28.0691 19.3486 28.3554C19.424 28.6417 19.528 28.876 19.6612 29.0583C19.7943 29.2406 19.9452 29.376 20.1143 29.4646C20.2834 29.5531 20.4617 29.5971 20.6497 29.5971C20.7069 29.5971 20.7834 29.5931 20.88 29.5851C20.976 29.5771 21.0726 29.5646 21.1692 29.5463C21.2652 29.528 21.3577 29.5034 21.4463 29.472C21.5349 29.4406 21.6 29.3966 21.6417 29.3394V27.9177H20.6652V27.2771L22.5714 27.2777Z" fill="white"/>\r\n</g>\r\n<defs>\r\n<clipPath id="clip0_10201_22041">\r\n<rect width="32" height="32" fill="white"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n',
  jpg: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n<g clip-path="url(#clip0_10201_22041)">\r\n<path d="M21.1343 0H4.55029C4.08858 0 3.71429 0.374286 3.71429 1.10057V31.4286C3.71429 31.6257 4.08858 32 4.55029 32H27.4497C27.9114 32 28.2857 31.6257 28.2857 31.4286V7.416C28.2857 7.01829 28.2326 6.89029 28.1389 6.796L21.4897 0.146857C21.3954 0.0531429 21.2674 0 21.1343 0Z" fill="#E9E9E0"/>\r\n<path d="M21.4286 0.0862732V6.85713H28.1994L21.4286 0.0862732Z" fill="#D9D7CA"/>\r\n<path d="M10.8177 10.8572C12.2597 10.8572 13.4286 9.68823 13.4286 8.24629C13.4286 6.80436 12.2597 5.63544 10.8177 5.63544C9.3758 5.63544 8.20688 6.80436 8.20688 8.24629C8.20688 9.68823 9.3758 10.8572 10.8177 10.8572Z" fill="#F3D55B"/>\r\n<path d="M3.71429 22.2857H10H28.2857V16L22.5714 10.5714L16.5714 17.1429L13.4383 14.0097L3.71429 22.2857Z" fill="#26B99A"/>\r\n<path d="M27.4497 32H4.55029C4.08858 32 3.71429 31.6257 3.71429 31.164V22.2857H28.2857V31.164C28.2857 31.6257 27.9114 32 27.4497 32Z" fill="#14A085"/>\r\n<path d="M12.2434 24.3714V28.856C12.2434 29.1269 12.1937 29.3549 12.0949 29.5394C11.996 29.724 11.8629 29.8726 11.6966 29.9846C11.5297 30.0966 11.3383 30.1749 11.1223 30.2189C10.9057 30.2634 10.6834 30.2857 10.4543 30.2857C10.3394 30.2857 10.2051 30.2737 10.052 30.2503C9.89829 30.2269 9.73943 30.1909 9.57543 30.1411C9.41143 30.0914 9.25372 30.0354 9.10286 29.9731C8.95143 29.9109 8.824 29.8406 8.72 29.7623L9.11829 29.1297C9.17029 29.1657 9.24457 29.204 9.34114 29.2429C9.43714 29.2817 9.54286 29.3183 9.65771 29.352C9.772 29.3863 9.892 29.4154 10.0171 29.4417C10.1423 29.468 10.2594 29.4806 10.3686 29.4806C10.6446 29.4806 10.8646 29.4269 11.0286 29.3206C11.1926 29.2143 11.2794 29.0326 11.2903 28.7777V24.3714H12.2434Z" fill="white"/>\r\n<path d="M14.5794 30.2468H13.6417V24.4886H15.2977C15.5423 24.4886 15.7846 24.5274 16.024 24.6057C16.2634 24.684 16.4783 24.8011 16.6686 24.9571C16.8589 25.1131 17.0126 25.3023 17.1297 25.5234C17.2469 25.7446 17.3057 25.9931 17.3057 26.2697C17.3057 26.5617 17.256 26.8257 17.1572 27.0628C17.0583 27.3 16.92 27.4994 16.7429 27.6606C16.5657 27.8217 16.352 27.9468 16.1023 28.0354C15.8526 28.124 15.576 28.168 15.2743 28.168H14.5789L14.5794 30.2468ZM14.5794 25.2V27.4811H15.4389C15.5532 27.4811 15.6663 27.4617 15.7789 27.4223C15.8909 27.3834 15.9937 27.3194 16.0874 27.2308C16.1812 27.1423 16.2566 27.0188 16.3137 26.86C16.3709 26.7011 16.3994 26.5046 16.3994 26.2703C16.3994 26.1766 16.3863 26.068 16.3606 25.9463C16.3343 25.824 16.2812 25.7068 16.2006 25.5948C16.1194 25.4828 16.0063 25.3891 15.8606 25.3137C15.7143 25.2377 15.5217 25.2 15.2823 25.2H14.5794Z" fill="white"/>\r\n<path d="M22.5714 27.2777V29.504C22.4514 29.6554 22.3177 29.7783 22.1692 29.8748C22.0206 29.9714 21.8646 30.0508 21.7006 30.1131C21.5366 30.1754 21.3674 30.22 21.1926 30.2457C21.0177 30.2731 20.8452 30.2857 20.6732 30.2857C20.3292 30.2857 20.0132 30.2234 19.724 30.0983C19.4349 29.9731 19.1823 29.7886 18.9663 29.5434C18.7503 29.2983 18.5806 28.9914 18.4583 28.6217C18.336 28.252 18.2749 27.8246 18.2749 27.3406C18.2749 26.8566 18.336 26.4303 18.4583 26.0634C18.5806 25.696 18.7497 25.3903 18.9663 25.1457C19.1823 24.9006 19.436 24.7148 19.728 24.5868C20.0194 24.4588 20.3349 24.3954 20.6732 24.3954C20.9857 24.3954 21.2772 24.4474 21.548 24.5514C21.8189 24.656 22.0606 24.812 22.2743 25.02L21.6257 25.5983C21.5006 25.4468 21.3572 25.3377 21.196 25.2703C21.0343 25.2028 20.868 25.1686 20.696 25.1686C20.5034 25.1686 20.3194 25.2046 20.1452 25.2777C19.9703 25.3508 19.8143 25.4743 19.6766 25.6486C19.5383 25.8234 19.4303 26.048 19.3526 26.3246C19.2749 26.6011 19.2326 26.9388 19.2274 27.34C19.2326 27.7308 19.2732 28.0691 19.3486 28.3554C19.424 28.6417 19.528 28.876 19.6612 29.0583C19.7943 29.2406 19.9452 29.376 20.1143 29.4646C20.2834 29.5531 20.4617 29.5971 20.6497 29.5971C20.7069 29.5971 20.7834 29.5931 20.88 29.5851C20.976 29.5771 21.0726 29.5646 21.1692 29.5463C21.2652 29.528 21.3577 29.5034 21.4463 29.472C21.5349 29.4406 21.6 29.3966 21.6417 29.3394V27.9177H20.6652V27.2771L22.5714 27.2777Z" fill="white"/>\r\n</g>\r\n<defs>\r\n<clipPath id="clip0_10201_22041">\r\n<rect width="32" height="32" fill="white"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n',
  png: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\r\n<g clip-path="url(#clip0_10201_22052)">\r\n<path d="M21.1343 0H4.55029C4.08858 0 3.71429 0.374286 3.71429 1.10057V31.4286C3.71429 31.6257 4.08858 32 4.55029 32H27.4497C27.9114 32 28.2857 31.6257 28.2857 31.4286V7.416C28.2857 7.01829 28.2326 6.89029 28.1389 6.796L21.4897 0.146857C21.3954 0.0531429 21.2674 0 21.1343 0Z" fill="#E9E9E0"/>\r\n<path d="M21.4286 0.0862732V6.85713H28.1994L21.4286 0.0862732Z" fill="#D9D7CA"/>\r\n<path d="M10.8177 10.8572C12.2597 10.8572 13.4286 9.68823 13.4286 8.24629C13.4286 6.80436 12.2597 5.63544 10.8177 5.63544C9.3758 5.63544 8.20688 6.80436 8.20688 8.24629C8.20688 9.68823 9.3758 10.8572 10.8177 10.8572Z" fill="#F3D55B"/>\r\n<path d="M3.71429 22.2857H10H28.2857V16L22.5714 10.5714L16.5714 17.1429L13.4383 14.0097L3.71429 22.2857Z" fill="#26B99A"/>\r\n<path d="M27.4497 32H4.55029C4.08858 32 3.71429 31.6257 3.71429 31.164V22.2857H28.2857V31.164C28.2857 31.6257 27.9114 32 27.4497 32Z" fill="#14A085"/>\r\n<path d="M9.33334 29.7011V24.0769H11.3381C11.7756 24.0769 12.1381 24.1565 12.4256 24.3158C12.713 24.4751 12.9281 24.693 13.0709 24.9694C13.2137 25.244 13.2851 25.5534 13.2851 25.8976C13.2851 26.2437 13.2128 26.5549 13.0682 26.8313C12.9254 27.106 12.7094 27.3238 12.4201 27.4849C12.1326 27.6442 11.7711 27.7239 11.3353 27.7239H9.95673V27.0044H11.2584C11.5349 27.0044 11.7592 26.9568 11.9313 26.8616C12.1034 26.7645 12.2297 26.6327 12.3102 26.4661C12.3908 26.2995 12.4311 26.11 12.4311 25.8976C12.4311 25.6853 12.3908 25.4967 12.3102 25.3319C12.2297 25.1671 12.1024 25.0381 11.9285 24.9447C11.7564 24.8513 11.5294 24.8046 11.2475 24.8046H10.1819V29.7011H9.33334Z" fill="white"/>\r\n<path d="M18.8194 24.0769V29.7011H18.0395L15.1807 25.5763H15.1285V29.7011H14.28V24.0769H15.0654L17.9269 28.2072H17.9791V24.0769H18.8194Z" fill="white"/>\r\n<path d="M23.8636 25.8537C23.8105 25.6871 23.7391 25.5379 23.6493 25.4061C23.5615 25.2724 23.4562 25.1589 23.3335 25.0655C23.2109 24.9703 23.0708 24.898 22.9134 24.8486C22.7577 24.7991 22.5866 24.7744 22.3998 24.7744C22.0831 24.7744 21.7975 24.8559 21.543 25.0188C21.2885 25.1818 21.0871 25.4207 20.9388 25.7356C20.7924 26.0487 20.7191 26.4322 20.7191 26.8863C20.7191 27.3421 20.7933 27.7275 20.9416 28.0424C21.0899 28.3573 21.2931 28.5962 21.5512 28.7592C21.8094 28.9221 22.1032 29.0036 22.4328 29.0036C22.7385 29.0036 23.0049 28.9414 23.2319 28.8169C23.4608 28.6924 23.6374 28.5166 23.7619 28.2896C23.8883 28.0607 23.9514 27.7916 23.9514 27.4822L24.1711 27.5234H22.5618V26.8231H24.7725V27.463C24.7725 27.9353 24.6719 28.3454 24.4705 28.6933C24.2709 29.0393 23.9945 29.3066 23.6411 29.4952C23.2896 29.6837 22.8868 29.778 22.4328 29.778C21.9238 29.778 21.4771 29.6609 21.0926 29.4265C20.71 29.1922 20.4116 28.8599 20.1974 28.4296C19.9832 27.9976 19.8761 27.4849 19.8761 26.8918C19.8761 26.4432 19.9383 26.0404 20.0628 25.6834C20.1873 25.3264 20.3621 25.0234 20.5873 24.7744C20.8143 24.5236 21.0807 24.3323 21.3865 24.2005C21.694 24.0668 22.03 24 22.3943 24C22.6982 24 22.9811 24.0449 23.2429 24.1346C23.5065 24.2243 23.7409 24.3515 23.9459 24.5163C24.1528 24.6811 24.324 24.877 24.4595 25.104C24.595 25.3292 24.6865 25.5791 24.7341 25.8537H23.8636Z" fill="white"/>\r\n</g>\r\n<defs>\r\n<clipPath id="clip0_10201_22052">\r\n<rect width="32" height="32" fill="white"/>\r\n</clipPath>\r\n</defs>\r\n</svg>\r\n',
};

const DragAndDropUpload = ({
  label,
  supportFormat = "jpg, png",
  text = "Drag & Drop your image",
  disabled = false,
  isDeletable = true,
  isDownloadable = false,
  uploadedFile,
  isMultiUpload = false,
  button = (
    <Button
      size="sm"
      hierarchy={{ type: "secondaryGrey", buttonText: "Upload file" }}
      icon={{
        icon: (
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 12.5V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 17.5H4.66667C4.22464 17.5 3.80072 17.3244 3.48816 17.0118C3.17559 16.6993 3 16.2754 3 15.8333V12.5M14.6667 6.66667L10.5 2.5M10.5 2.5L6.33333 6.66667M10.5 2.5V12.5"
              stroke="#344054"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        ),
        type: "leading",
      }}
    />
  ),
  onDragOver,
  onDrop,
  onUpload,
  file,
  onRemoveFile,
  isSuccessfullyUpload = true,
  onDownload,
  hintText,
  destructive = false,
  className=""
}) => {
  const onDownloadFile = () => {
    const anchor = document.createElement("a");
    anchor.target = "_blank";
    anchor.href = window.URL.createObjectURL(file);
    anchor.download = file.name ?? "file";
    anchor.click();
    if (onDownload) onDownload();
  };

  if (!uploadedFile) {
    uploadedFile = (
      <UploadedFile
        file={file}
        onRemoveFile={onRemoveFile}
        isDeletable={isDeletable}
        isDownloadable={isDownloadable}
        isSuccessfullyUpload={isSuccessfullyUpload}
        onDownload={onDownloadFile}
      />
    );
  }

  const inputRef = useRef();

  console.log("file:",file);
  
  return (
    <div
      className={`dragAndDropUploadContainer${
        destructive ? " destructive" : ""
      } ${className}`}
    >
      {label && <label className="dragAndDropUploadLabel">{label}</label>}

      <div
        className="dragAndDropUploadSec"
        onDrop={onDrop}
        onDragOver={onDragOver}
      >
        {isMultiUpload ? (
          file && file.length >= 1 ? (
            <>
              <div className="dragAndDropMultiUploadSec">
                <Button
                  size="sm"
                  onClick={() => {
                    inputRef.current.click();
                  }}
                  hierarchy={{
                    type: "tertiaryGrey",
                    buttonText: "Add Attachment",
                  }}
                />
                <input
                  type="file"
                  multiple
                  id="fileInput"
                  ref={inputRef}
                  onChange={onUpload}
                  disabled={disabled}
                  accept={supportFormat}
                  className="dragAndDropUploadInput"
                />
              </div>
              {uploadedFile}
            </>
          ) : (
            <>
              <div className="dragAndDropUploadTopSec">
                <div className="dragAndDropUploadText">{text}</div>
                <div className="dragAndDropUploadSupFormat">
                  Supported formats ({supportFormat})
                </div>
              </div>
              <div className="dragAndDropUploadOrText">or</div>
              <input
                type="file"
                multiple
                id="fileInput"
                onChange={onUpload}
                disabled={disabled}
                accept={supportFormat}
                className="dragAndDropUploadInput"
              />
              <div className="dragAndDropUploadBtn">{button}</div>
            </>
          )
        ) : file ? (
          uploadedFile
        ) : (
          <>
            <div className="dragAndDropUploadTopSec">
              <div className="dragAndDropUploadText">{text}</div>
              <div className="dragAndDropUploadSupFormat">
                Supported formats ({supportFormat})
              </div>
            </div>
            <div className="dragAndDropUploadOrText">or</div>
            <input
              type="file"
              id="fileInput"
              onChange={onUpload}
              disabled={disabled}
              accept={supportFormat}
              className="dragAndDropUploadInput"
            />
            <div className="dragAndDropUploadBtn">{button}</div>
          </>
        )}
      </div>
      {hintText && (
        <span className="dragAndDropUploadHintText">{hintText}</span>
      )}
    </div>
  );
};

export default DragAndDropUpload;

const UploadedFile = ({
  file,
  onRemoveFile,
  isDeletable,
  isDownloadable,
  isSuccessfullyUpload,
  onDownload,
}) => {
  return (
    <div className="uploadedFileContainer">
      <div className="uploadedFileSec">
        <div className="uploadedFileDetailSec">
          {/* <img
            className="uploadedFileImage"
            src={window.URL.createObjectURL(file)}
            alt={file.name}
          /> */}
          <div
            className="uploadedFileImage"
            dangerouslySetInnerHTML={{
              __html: images[file.type.split("/")[1]],
            }}
          />
          <div className="uploadedFileDetail">
            <div className="uploadedFileName">
              <span>{file.name}</span>
              {isDownloadable ? (
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={onDownload}
                >
                  <path
                    d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
                    stroke="#344054"
                    strokeWidth="1.67"
                    strokLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : null}
            </div>

            <div className="uploadedFileSize">
              {Math.floor(file.size / 125000)} MB
            </div>
          </div>
        </div>
        {isDeletable && (
          <svg
            width="17"
            height="16"
            viewBox="0 0 17 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onRemoveFile}
            className="uploadedFileRemoveIcon"
          >
            <path
              d="M2.5 3.99967H3.83333M3.83333 3.99967H14.5M3.83333 3.99967V13.333C3.83333 13.6866 3.97381 14.0258 4.22386 14.2758C4.47391 14.5259 4.81304 14.6663 5.16667 14.6663H11.8333C12.187 14.6663 12.5261 14.5259 12.7761 14.2758C13.0262 14.0258 13.1667 13.6866 13.1667 13.333V3.99967H3.83333ZM5.83333 3.99967V2.66634C5.83333 2.31272 5.97381 1.97358 6.22386 1.72353C6.47391 1.47348 6.81304 1.33301 7.16667 1.33301H9.83333C10.187 1.33301 10.5261 1.47348 10.7761 1.72353C11.0262 1.97358 11.1667 2.31272 11.1667 2.66634V3.99967M7.16667 7.33301V11.333M9.83333 7.33301V11.333"
              stroke="#F04438"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      {isSuccessfullyUpload ? (
        <div className="uploadedFileStatusSec">
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="0.5" width="20" height="20" rx="10" fill="#039855" />
            <path
              d="M14.5 7L9 12.5L6.5 10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <div className="uploadedFileStatusText"> Uploaded Successfully</div>
        </div>
      ) : null}
    </div>
  );
};

DragAndDropUpload.propTypes = {
  label: PropTypes.string,
  onUpload: PropTypes.func.isRequired,
  onDragOver: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  text: PropTypes.string,
  supportFormat: PropTypes.string,
  disabled: PropTypes.bool,
  button: PropTypes.node,
  onRemoveFile: PropTypes.func,
  isDeletable: PropTypes.bool,
  isDownloadable: PropTypes.bool,
  onDownload: PropTypes.func,
  hintText: PropTypes.string,
  destructive: PropTypes.bool,
};
